/**
 * Translations for the zoo feature area.
 */
const zoo = {
  zh: {
    'zoo.title': '🏞️ 我的动物乐园',
    'zoo.subtitle.goal': '👑 你的目标：成为最棒的动物乐园园长',
    'zoo.subtitle.stats': '{lands} 块地 · {buildings} 座建筑 · {pets} 只动物',

    'zoo.view.scene': '🗺️ 地图视图',
    'zoo.view.list': '📋 列表视图',

    'zoo.map.kicker': '园长地图',
    'zoo.map.title': '我的动物乐园地图',
    'zoo.map.subtitle': '买地会点亮新的乐园区域；每块区域可以盖建筑、安排动物入住。',
	    'zoo.map.opened': '已开放区域',
	    'zoo.map.progress': '已开放 {open}/{total} 个乐园区域',
	    'zoo.map.route.aria': '乐园建设路线',
	    'zoo.map.highlight': '正在查看「{name}」',
    'zoo.map.status.open': '已开放',
    'zoo.map.status.locked': '待升级',
    'zoo.map.status.ready': '可购买',
    'zoo.map.status.saving': '攒金币',
    'zoo.map.stat.land': '{n} 块地',
    'zoo.map.stat.buildings': '建筑 {n}/{cap}',
    'zoo.map.stat.animals': '{n} 只动物',
    'zoo.map.buildHere': '+ 盖建筑',
    'zoo.map.viewZone': '查看区域',
    'zoo.map.unlockLevel': 'Lv.{level} 解锁',
    'zoo.map.buyFor': '买地 {amount}',
    'zoo.map.saveFor': '需要 {amount}',
    'zoo.map.zone.backyard.species': '适合：仓鼠、兔子、小型动物',
    'zoo.map.zone.backyard.role': '园长的第一块照顾区，适合放小笼子和基础玩具。',
    'zoo.map.zone.garden.species': '适合：兔子、鸟类、乌龟和温和动物',
    'zoo.map.zone.garden.role': '更开阔的花园区，可以开始规划多个动物小家。',
    'zoo.map.zone.ranch.species': '适合：狗、水豚、水獭和活泼动物',
    'zoo.map.zone.ranch.role': '真正有动物园感觉的活动区，适合大型建筑和运动玩具。',
    'zoo.map.zone.estate.species': '适合：稀有动物、大型动物和特别展区',
    'zoo.map.zone.estate.role': '高级园长区域，未来可以放珍稀动物馆和主题展区。',
    'zoo.map.zone.default.species': '适合：按建筑限制安排动物',
    'zoo.map.zone.default.role': '新的乐园区域，等待园长规划。',

    'zoo.habitat.title': '栖息地适配',
    'zoo.habitat.empty': '还没有动物入住',
    'zoo.habitat.match': '{matched}/{total} 住得合适',
    'zoo.habitat.recommended': '推荐动物',
    'zoo.habitat.summary': '适配 {matched}/{total}',
    'zoo.habitat.assignFit': '栖息地：{fit}',
    'zoo.habitat.fit.ideal': '最合适',
    'zoo.habitat.fit.good': '适合',
    'zoo.habitat.fit.ok': '可住',
    'zoo.habitat.fit.mismatch': '不太适合',

    'zoo.overcrowd.title': '🏠 住不下啦！',
    'zoo.overcrowd.body': '你有 {pets} 只宠物但只能住 {capacity} 只。去买块地再盖个新建筑吧～',

    'zoo.pets.heading': '🐾 我的宠物（{n}）',
    'zoo.pets.breed.cta': '💕 繁育',
    'zoo.pets.home': '🏠 {name}',
    'zoo.pets.noHome': '🏚️ 无家',
    'zoo.pets.empty': '还没有宠物，',
    'zoo.pets.empty.link': '去商店买一只',

    'zoo.unassigned.heading': '🏚️ 还没家的宠物（{n}）',
    'zoo.unassigned.helper': '点一只给它分配一个建筑做家',

    'zoo.breeding.heading': '💕 繁育中（{n}）',
    'zoo.breeding.ready': '宝宝出生了！',
    'zoo.breeding.remaining': '还要 {min} 分钟',
    'zoo.breeding.claim': '🎁 领取宝宝',
    'zoo.breeding.claimed': '🎉 恭喜！新宝宝 {name} 出生了！',

    'zoo.lands.heading': '🏞️ 我的土地（{n}）',
    'zoo.lands.buy': '+ 买地',
    'zoo.lands.empty.title': '这里还是一片荒野',
    'zoo.lands.empty.hint': '去 商店 → 🏞️ 动物乐园 买一块地，开始建造你的乐园！',
    'zoo.lands.empty.cta': '🛍️ 去商店买地',
    'zoo.lands.row.title': '🏞️ {name}',
    'zoo.lands.row.buildings': '建筑：{built}/{cap}',
    'zoo.lands.row.build': '+ 盖建筑',

    'zoo.bld.row.title': '🏠 {name}',
    'zoo.bld.row.species': '限 {emojis}',
    'zoo.bld.row.enter': '进入',

    'zoo.scene.allFull': '所有土地建筑位都满了，先买新地吧 🌾',
    'zoo.scene.pickLand': '请在列表视图选择要盖建筑的土地',

    'zoo.toast.built': '🏠 盖了一座 {name}！',
    'zoo.toast.movedOut': '{name} 搬出来了',
    'zoo.toast.movedIn': '{name} 搬新家了 🏠',
    'zoo.toast.assigned': '{pet} 搬进了 {building} 🏠',

    'zoo.build.title': '🏠 在「{land}」上盖建筑',
    'zoo.build.balance': '你的金币：{amount}',
    'zoo.build.price': '{amount} · 容量 {cap}',
    'zoo.build.priceSpecies': '{amount} · 容量 {cap} · 限 {emojis}',
    'zoo.build.locked': '🔒 Lv.{level}',
    'zoo.build.cta': '盖！',
    'zoo.build.lockedTooltip': '需要 Lv.{level} 才能盖',

    'zoo.assign.title': '🏠 给 {name} 分配家',
    'zoo.assign.helper': '选一个建筑（必须物种匹配 + 容量够）',
    'zoo.assign.full': '已满',
    'zoo.assign.current': '当前家',
    'zoo.assign.available': '可入住',
    'zoo.assign.moveOut': '🚪 搬走（无家）',

    'zoo.breed.title': '💕 宠物繁育',
    'zoo.breed.intro': '两只同物种宠物（等级 ≥ 3）可以一起繁育，24 小时后生宝宝。',
    'zoo.breed.notEnough': '还没有足够等级 3+ 的宠物 😊',
    'zoo.breed.parentA': '爸爸 / 妈妈 A',
    'zoo.breed.parentB': '爸爸 / 妈妈 B（同物种）',
    'zoo.breed.noB': '没有同物种的其他等级 3+ 宠物',
    'zoo.breed.start': '💕 开始繁育',
    'zoo.breed.started': '💕 繁育开始！24 小时后可以领宝宝',

    'zoo.error.fallback': '出错了',
  } as Record<string, string>,
  en: {
    'zoo.title': '🏞️ My animal park',
    'zoo.subtitle.goal': '👑 Your goal: become the best animal park director',
    'zoo.subtitle.stats': '{lands} lands · {buildings} buildings · {pets} animals',

    'zoo.view.scene': '🗺️ Map view',
    'zoo.view.list': '📋 List view',

    'zoo.map.kicker': 'Keeper map',
    'zoo.map.title': 'My animal park map',
    'zoo.map.subtitle': 'Buying land lights up new park zones. Each zone can hold buildings and animal homes.',
	    'zoo.map.opened': 'zones open',
	    'zoo.map.progress': '{open}/{total} park zones open',
	    'zoo.map.route.aria': 'Park build route',
	    'zoo.map.highlight': 'Viewing "{name}"',
    'zoo.map.status.open': 'Open',
    'zoo.map.status.locked': 'Level locked',
    'zoo.map.status.ready': 'Ready to buy',
    'zoo.map.status.saving': 'Save coins',
    'zoo.map.stat.land': '{n} land(s)',
    'zoo.map.stat.buildings': 'Buildings {n}/{cap}',
    'zoo.map.stat.animals': '{n} animals',
    'zoo.map.buildHere': '+ Build',
    'zoo.map.viewZone': 'View zone',
    'zoo.map.unlockLevel': 'Unlocks Lv.{level}',
    'zoo.map.buyFor': 'Buy {amount}',
    'zoo.map.saveFor': 'Need {amount}',
    'zoo.map.zone.backyard.species': 'Best for: hamsters, rabbits, small animals',
    'zoo.map.zone.backyard.role': 'The keeper’s first care zone, good for starter homes and basic toys.',
    'zoo.map.zone.garden.species': 'Best for: rabbits, birds, turtles, gentle animals',
    'zoo.map.zone.garden.role': 'A wider garden zone where multiple animal homes can start to form.',
    'zoo.map.zone.ranch.species': 'Best for: dogs, capybaras, otters, active animals',
    'zoo.map.zone.ranch.role': 'A real zoo-feeling activity zone for larger buildings and motion toys.',
    'zoo.map.zone.estate.species': 'Best for: rare animals, large animals, special exhibits',
    'zoo.map.zone.estate.role': 'A senior keeper zone for rare habitats and themed exhibits later.',
    'zoo.map.zone.default.species': 'Best for: animals that match the building rules',
    'zoo.map.zone.default.role': 'A new park zone waiting for the keeper’s plan.',

    'zoo.habitat.title': 'Habitat fit',
    'zoo.habitat.empty': 'No animals live here yet',
    'zoo.habitat.match': '{matched}/{total} well matched',
    'zoo.habitat.recommended': 'Recommended animals',
    'zoo.habitat.summary': 'Fit {matched}/{total}',
    'zoo.habitat.assignFit': 'Habitat: {fit}',
    'zoo.habitat.fit.ideal': 'Ideal',
    'zoo.habitat.fit.good': 'Good',
    'zoo.habitat.fit.ok': 'Okay',
    'zoo.habitat.fit.mismatch': 'Not ideal',

    'zoo.overcrowd.title': '🏠 Out of room!',
    'zoo.overcrowd.body': "You have {pets} pets but only {capacity} spots. Buy more land and build a new home～",

    'zoo.pets.heading': '🐾 My pets ({n})',
    'zoo.pets.breed.cta': '💕 Breed',
    'zoo.pets.home': '🏠 {name}',
    'zoo.pets.noHome': '🏚️ No home',
    'zoo.pets.empty': 'No pets yet, ',
    'zoo.pets.empty.link': 'go to the shop to adopt one',

    'zoo.unassigned.heading': '🏚️ Pets without a home ({n})',
    'zoo.unassigned.helper': 'Tap one to assign it a building',

    'zoo.breeding.heading': '💕 Breeding ({n})',
    'zoo.breeding.ready': 'Baby is born!',
    'zoo.breeding.remaining': '{min} min left',
    'zoo.breeding.claim': '🎁 Claim baby',
    'zoo.breeding.claimed': '🎉 Congrats! New baby {name} is born!',

    'zoo.lands.heading': '🏞️ My lands ({n})',
    'zoo.lands.buy': '+ Buy land',
    'zoo.lands.empty.title': "It's all wilderness here",
    'zoo.lands.empty.hint': 'Go to Shop → 🏞️ Animal Park and buy land to start your park!',
    'zoo.lands.empty.cta': '🛍️ Buy land in shop',
    'zoo.lands.row.title': '🏞️ {name}',
    'zoo.lands.row.buildings': 'Buildings: {built}/{cap}',
    'zoo.lands.row.build': '+ Build',

    'zoo.bld.row.title': '🏠 {name}',
    'zoo.bld.row.species': 'only {emojis}',
    'zoo.bld.row.enter': 'Enter',

    'zoo.scene.allFull': 'Every land is full — buy a new one first 🌾',
    'zoo.scene.pickLand': 'Switch to list view and pick a land to build on',

    'zoo.toast.built': '🏠 Built a new {name}!',
    'zoo.toast.movedOut': '{name} moved out',
    'zoo.toast.movedIn': '{name} moved in 🏠',
    'zoo.toast.assigned': '{pet} moved into {building} 🏠',

    'zoo.build.title': '🏠 Build on "{land}"',
    'zoo.build.balance': 'Your coins: {amount}',
    'zoo.build.price': '{amount} · capacity {cap}',
    'zoo.build.priceSpecies': '{amount} · capacity {cap} · only {emojis}',
    'zoo.build.locked': '🔒 Lv.{level}',
    'zoo.build.cta': 'Build!',
    'zoo.build.lockedTooltip': 'Requires Lv.{level} to build',

    'zoo.assign.title': '🏠 Assign a home to {name}',
    'zoo.assign.helper': 'Pick a building (matching species + room)',
    'zoo.assign.full': 'Full',
    'zoo.assign.current': 'Current home',
    'zoo.assign.available': 'Available',
    'zoo.assign.moveOut': '🚪 Move out (no home)',

    'zoo.breed.title': '💕 Pet breeding',
    'zoo.breed.intro': 'Two pets of the same species (level ≥ 3) can breed — a baby arrives in 24 hours.',
    'zoo.breed.notEnough': 'Not enough level 3+ pets yet 😊',
    'zoo.breed.parentA': 'Parent A',
    'zoo.breed.parentB': 'Parent B (same species)',
    'zoo.breed.noB': 'No other level 3+ pets of the same species',
    'zoo.breed.start': '💕 Start breeding',
    'zoo.breed.started': "💕 Breeding started! Come back in 24 hours to claim the baby",

    'zoo.error.fallback': 'Something went wrong',
  } as Record<string, string>,
};

export default zoo;
